import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "scroll-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!
  const _component_CraftPanel = _resolveComponent("CraftPanel")!
  const _component_GenericPanel = _resolveComponent("GenericPanel")!

  return (_openBlock(), _createBlock(_component_GenericPanel, {
    "class-name": "char-stats-container",
    title: _ctx.getTitle()
  }, {
    "icons-right": _withCtx(() => [
      _createVNode(_component_GenericButton, {
        svg: "close",
        onClick: _ctx.closePanel
      }, null, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_CraftPanel)
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}